import { Skeleton, Stack } from '@mui/material';

const GuarantorCompletionSkeleton = () => {
    return (
        <>
            <div className="pt-20 centerClassMaxWith">
                <Stack spacing={3}>
                    <Skeleton variant="text" width="50%" height={30} />
                    <Skeleton variant="rounded" height={'183px'} sx={{ marginTop: '16px' }} />
                    <Skeleton variant="text" width="50%" height={30} />
                    <Skeleton variant="rounded" height={'100px'} sx={{ marginTop: '16px' }} />
                    <Skeleton variant="text" width="50%" height={30} />
                    <Skeleton variant="rounded" height={'100px'} sx={{ marginTop: '16px' }} />
                    <Skeleton variant="text" width="50%" height={30} />
                    <Skeleton variant="rounded" height={'60px'} sx={{ marginTop: '16px' }} />
                    <Skeleton variant="rounded" height={'100px'} sx={{ marginTop: '16px' }} />
                </Stack>
            </div>
        </>
    );
};

export default GuarantorCompletionSkeleton;
